import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type AffiliateStatsCardProps = {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
    comparisonLabel?: string; // e.g., "vs last 7 days", "vs last month"
  };
  className?: string;
  valueClassName?: string;
};

export const AffiliateStatsCard = ({
  title,
  value,
  subtitle,
  trend,
  className,
  valueClassName,
}: AffiliateStatsCardProps) => {
  return (
    <div
      className={cn(
        "rounded-xl bg-card p-3 border border-border/50 shadow-sm dark:shadow-none",
        className
      )}
    >
      <div className="space-y-1">
        <div className="flex items-start justify-between gap-2">
          <p className="text-xs text-muted-foreground uppercase tracking-wider font-medium truncate">
            {title}
          </p>
          {subtitle && (
            <p className="text-xs text-muted-foreground truncate shrink-0">{subtitle}</p>
          )}
        </div>
        <p className={cn("text-lg md:text-xl font-bold tracking-tight truncate", valueClassName)}>
          {value}
        </p>
        {trend && (
          <p
            className={cn(
              "text-xs font-medium",
              trend.isPositive ? "text-emerald-500" : "text-rose-500"
            )}
          >
            {trend.isPositive ? "↑" : "↓"} {Math.abs(trend.value).toFixed(1)}% {trend.comparisonLabel || "vs last month"}
          </p>
        )}
      </div>
    </div>
  );
};

